import * as rudderanalytics from "rudder-sdk-js";
import store from "@/store";
import { PartnerSettingsState } from "@/store/modules/partnerModule";

let isInitialized = false;
let isLoaded = false;

// Initializes the RudderStack JS SDK using the per-partner runtime config
// fetched from the customerSettings API (PartnerSettings.rudderWriteKeyWsa / rudderDataPlaneUrlWsa).
// Safe to call multiple times - only loads once. Must be called after partnerSettings
// have been fetched (App.vue calls this inside the getPartnerSettings().then() block).
export function initRudderStack(): void {
    if (isInitialized) {
        return;
    }
    isInitialized = true;

    const partnerSettings = ((store as any).state["partner"] as PartnerSettingsState).partnerSettings;
    const writeKey = partnerSettings?.rudderWriteKeyWsa;
    const dataPlaneUrl = partnerSettings?.rudderDataPlaneUrlWsa;

    if (!writeKey || !dataPlaneUrl) {
        console.warn("RudderStack: missing rudderWriteKeyWsa or rudderDataPlaneUrlWsa in partnerSettings - analytics calls will be ignored.");
        return;
    }

    try {
        rudderanalytics.load(writeKey, dataPlaneUrl);
        rudderanalytics.ready(() => {
            isLoaded = true;
        });
    } catch (error) {
        console.warn("RudderStack: failed to initialize.", error);
    }
}

export function rsPage(name: string, properties?: Record<string, any>): void {
    if (!isLoaded) {
        console.warn(`RudderStack: page('${name}') called before SDK was ready - skipping.`);
        return;
    }

    try {
        rudderanalytics.page(name, properties || {});
    } catch (error) {
        console.warn(`RudderStack: failed to log page '${name}'.`, error);
    }
}

export function rsTrack(event: string, properties?: Record<string, any>): void {
    if (!isLoaded) {
        console.warn(`RudderStack: track('${event}') called before SDK was ready - skipping.`);
        return;
    }

    try {
        rudderanalytics.track(event, properties || {});
    } catch (error) {
        console.warn(`RudderStack: failed to log event '${event}'.`, error);
    }
}

export function rsIdentify(userId: string, traits?: Record<string, any>): void {
    if (!isLoaded) {
        console.warn(`RudderStack: identify('${userId}') called before SDK was ready - skipping.`);
        return;
    }

    try {
        rudderanalytics.identify(userId, traits || {});
    } catch (error) {
        console.warn(`RudderStack: failed to identify user '${userId}'.`, error);
    }
}
